import { BaseEntity, DefaultResponseWithData } from "./system";

export enum TicketStatus {
  Open = 0,
  InProgress = 1,
  Resolved = 2,
  Closed = 3,
}

export enum TicketPriority {
  Low = 0,
  Medium = 1,
  High = 2,
  Urgent = 3,
}

export enum TicketType {
  Bug = 0,
  Feature = 1,
}

export interface ITicketNote extends BaseEntity {
  ticketId: string;
  userId: string;
  authorName?: string;
  authorEmail?: string;
  note: string;
  isInternal: boolean;
  isFromStaff?: boolean;
}

export interface ITicketAttachment extends BaseEntity {
  ticketId: string;
  uploadedByUserId: string;
  fileName: string;
  contentType: string;
  fileSize: number;
}

export interface ITicket extends BaseEntity {
  customerId: string;
  createdByUserId: string;
  assignedToUserId?: string;
  subject: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  type: TicketType;
  notes: ITicketNote[];
  attachments: ITicketAttachment[];
}

export interface IGetTicketsResponse extends DefaultResponseWithData<ITicket[]> {}
export interface IGetTicketResponse extends DefaultResponseWithData<ITicket> {}

export interface ICreateTicketRequest {
  customerId?: string;
  createdByUserId?: string;
  assignedToUserId?: string;
  subject: string;
  description: string;
  priority: TicketPriority;
  type: TicketType;
}

export interface IUpdateTicketRequest {
  subject: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  /** Omit to leave the stored type untouched. */
  type?: TicketType;
  assignedToUserId?: string;
}

export interface IAddTicketCommentRequest {
  note: string;
  isInternal?: boolean;
  userId?: string;
  authorName?: string;
  authorEmail?: string;
}
